export const FEED_TEMPLATES = {
  YANDEX_MARKET: {
    name: 'Яндекс.Маркет',
    description: 'Стандартный YML формат для Яндекс.Маркет',
    root_tag: 'yml_catalog',
    item_tag: 'offer',
    field_tags: {
      'id': 'name',
      'name': 'name',
      'price': 'price',
      'currencyId': 'price',
      'categoryId': 'category',
      'picture': 'images',
      'description': 'description',
      'available': 'current_amount',
    }
  },
  GOOGLE_SHOPPING: {
    name: 'Google Shopping',
    description: 'Фид для Google Merchant Center',
    root_tag: 'rss',
    item_tag: 'item',
    field_tags: {
      'g:id': 'name',
      'g:title': 'name',
      'g:description': 'description',
      'g:price': 'price',
      'g:image_link': 'images',
      'g:availability': 'current_amount',
      'g:product_type': 'category',
    }
  },
  FACEBOOK_CATALOG: {
    name: "Facebook Product Catalog",
    description: "Каталог товаров для динамической рекламы в Facebook",
    root_tag: "rss",
    item_tag: "item",
    field_tags: {
      "id": "name",
      "title": "name",
      "description": "description",
      "price": "price",
      "availability": "current_amount",
      "image_link": "images",
      "product_type": "category"
    }
  },
  WILDBERRIES: {
    name: 'Wildberries',
    description: 'Фид для маркетплейса Wildberries',
    root_tag: 'yml_catalog',
    item_tag: 'offer',
    field_tags: {
      'id': 'name',
      'name': 'name',
      'price': 'price',
      'currencyId': 'RUB',
      'categoryId': 'category',
      'picture': 'images',
      'description': 'description',
      'barcode': 'code',
      'vendorCode': 'code',
      'quantity': 'current_amount',
    }
  },
  OZON: {
    name: 'Ozon',
    description: 'Фид для маркетплейса Ozon',
    root_tag: 'yml_catalog',
    item_tag: 'offer',
    field_tags: {
      'id': 'name',
      'name': 'name',
      'price': 'price',
      'currencyId': 'RUB',
      'categoryId': 'category',
      'picture': 'images',
      'description': 'description',
      'barcode': 'code',
      'vendor_code': 'code',
      'quantity': 'current_amount',
      'param': 'attributes',
    }
  },
  FLOWWOW: {
    name: 'Flowwow',
    description: 'Фид для маркетплейса Flowwow с характеристиками',
    root_tag: 'yml_catalog',
    item_tag: 'offer',
    field_tags: {
      'name': 'name',
      'picture': 'images',
      'price': 'price',
      'description': 'description',
      'qty': 'current_amount',
      'param': 'attributes',
      'consist': 'attributes',
    }
  }
};